


























































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { dashboardService } from "@/services/dash";
import { Moment } from "moment";
import { Desk, Office, Reservation } from "@/swagger/models";
import DataTable from "@/components/data/data-table.vue";
import { DataTableField } from "@/components/data/data-table";
import ReservationGraph from "@/components/data/reservations-graph.vue";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "occupancyModal",
    components: { ReservationGraph, DataTable },
})
export default class OccupancyModal extends Vue {
    @Prop({ required: true })
    officeId: number;

    @Prop({ required: true })
    date: Moment;

    open: boolean = false;

    deskFilters = [
        {
            text: "All desks",
            value: "all",
        },
        {
            text: "Desks without reservations",
            value: "free",
        },
        {
            text: "Desks with reservations",
            value: "booked",
        },
    ];

    deskFilter = "all";

    officeData: Office = null;

    deskFields: DataTableField<Partial<Reservation>>[] = [
        {
            label: "Desk",
            field: "name",
            width: "25%",
        },
        {
            label: "Reservations during the day",
            field: "reservations",
        },
    ];

    @Watch("open")
    async refreshData() {
        if (!this.open) return;

        this.officeData = await dashboardService.getOffice(this.officeId, this.date);
    }

    getFilteredDesks(desks) {
        switch (this.deskFilter) {
            case "free":
                return desks.filter((d) => d.reservations.length === 0);
            case "booked":
                return desks.filter((d) => d.reservations.length > 0);
            default:
                return desks;
        }
    }
}
